export default __webpack_public_path__ + "static/media/ritual-make2.cfe927c8.png";